import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { renderToString } from 'react-dom/server';

import { getFancyboxButtonShareTpl } from 'components/FancyboxButtons/FancyboxButtonShare';
import SharingPopup from 'components/SharingPopup';
import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';
import { storageKeys } from 'config/settings.json';

import Swal2 from 'sweetalert2';
// import withReactContent from 'sweetalert2-react-content';

// const Swal = withReactContent(Swal2);

const settings = {};
let buttonCompleted = '';

const REQUIRED_TYPES = ['pdf', 'video', 'audio', 'image', 'infographic'];

const trackShare = (type, value, title) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      const email = userObj && userObj.email ? userObj.email : 'Guest';
      APIHandler.trackEvent(appId, email, 'videos', type, value, title);
    });
  });
};

/**
 *
 * @param {Object} props
 * @param {string} props.htmlText
 * @param {string} props.icon
 * @returns {JSX.Element}
 */
function HtmlTextButton({ htmlText, icon }) {
  const onClick = () => {
    Swal2.fire({
      html: htmlText,
    });
  };

  return (
    <button className="linkButton" onClick={onClick}>
      <FontAwesomeIcon icon={icon} />
    </button>
  );
}

const setType = (url, target, icon, fancybox, type, shareTitle = '') => {
  settings.url = url;
  settings.target = target;
  settings.icon = icon;
  settings.fancybox = fancybox;
  settings.type = type;
  settings.shareTitle = shareTitle || '';

  const newIcon = url.includes('spotify') ? 'fab fa-spotify' : icon;

  return (
    <ButtonElement
      url={settings.url}
      fancybox={settings.fancybox}
      target={settings.target}
      icon={newIcon}
      type={settings.type}
      shareTitle={settings.shareTitle}
    />
  );
};

const ButtonElement = (props) => {
  const { fancybox, icon, target, type, url, shareTitle } = props;
  const sharingTitle = shareTitle && shareTitle.toString().trim() ? shareTitle.toString().trim() : '';

  if (icon === 'fas fa-image') {
    return (
      <a
        id={`${type}-${url}`}
        target={target}
        href={url}
        data-fancybox={type}
        data-type={type}
        data-trigger={fancybox}
        onClick={buttonCompleted}
        data-options={JSON.stringify({
          buttons: ['thumbs', 'share', 'close'],
          share: {
            tpl: renderToString(<SharingPopup url={url} title={sharingTitle} />),
          },
          btnTpl: { share: getFancyboxButtonShareTpl() },
        })}
      >
        <button className="linkButton">
          <FontAwesomeIcon icon={icon.replace('fa-', '').split(' ')} />
        </button>
      </a>
    );
  }

  if (icon === 'fa fa-image') {
    return (
      <a
        id={`${type}-${url}`}
        target={target}
        href={url}
        data-fancybox={type}
        data-type={type}
        data-trigger={fancybox}
        onClick={buttonCompleted}
        data-options={JSON.stringify({
          buttons: ['thumbs', 'share', 'close'],
          share: {
            tpl: renderToString(<SharingPopup url={url} title={sharingTitle} />),
          },
          btnTpl: { share: getFancyboxButtonShareTpl() },
        })}
      >
        <button className="linkButton">
          <FontAwesomeIcon icon={icon.replace('fa-', '').split(' ')} />
        </button>
      </a>
    );
  }

  if (icon === 'fa fa-link') {
    return (
      <a id={`${type}-${url}`} target="_blank" href={url} onClick={buttonCompleted} rel="noreferrer">
        <button className="linkButton">
          <FontAwesomeIcon icon={icon.replace('fa-', '').split(' ')} />
        </button>
      </a>
    );
  }

  if (icon === 'fas fa-link') {
    return (
      <a id={`${type}-${url}`} target="_blank" href={url} onClick={buttonCompleted} rel="noreferrer">
        <button className="linkButton">
          <FontAwesomeIcon icon={icon.replace('fa-', '').split(' ')} />
        </button>
      </a>
    );
  }

  if (icon === 'fab fa-youtube') {
    return (
      <a
        id={`${type}-${url}`}
        target={target}
        href={url}
        data-fancybox={url}
        data-type={type}
        data-trigger={fancybox}
        onClick={buttonCompleted}
        data-options={JSON.stringify({
          buttons: ['thumbs', 'close'],
        })}
      >
        <button className="linkButton">
          <FontAwesomeIcon icon={icon.replace('fa-', '').split(' ')} />
        </button>
      </a>
    );
  }

  return (
    <a
      id={`${type}-${url}`}
      target={target}
      href={url}
      data-fancybox={url}
      data-type={type}
      data-trigger={fancybox}
      onClick={buttonCompleted}
      data-options={JSON.stringify({
        buttons: ['thumbs', 'share', 'close'],
        share: {
          tpl: renderToString(<SharingPopup url={url} title={sharingTitle} />),
        },
        btnTpl: { share: getFancyboxButtonShareTpl() },
      })}
    >
      <button className="linkButton">
        <FontAwesomeIcon icon={icon.replace('fa-', '').split(' ')} />
      </button>
    </a>
  );
};

const setButtonType = (link, type, appId, id = null, shareTitle = '') => {
  let newLink = '';
  const typeWithoutIndex = type.replace(/[0-9]/g, '');

  switch (typeWithoutIndex) {
    case 'weblink':
      return setType(link, '_blank', 'fa fa-link', null, null, shareTitle);

    case 'slideshow':
      return setType('', '', 'fa fa-image', id, null, shareTitle);

    case 'map':
      return setType(link, '', 'fa fa-map', 'single_media_map', null, shareTitle);

    case 'salestip':
      return setType('', '', 'fa fa-hand-point-right', 'single_media_salestip', type, shareTitle);

    case 'video':
      newLink = link.substring(0, link.indexOf('.'));
      return setType(
        `https://front.travpromobile.com/${appId}/${newLink}.mp4`,
        '_blank',
        'fa fa-video',
        'iframe',
        undefined,
        shareTitle,
      );

    case 'audio':
      newLink = link.includes('http')
        ? link
        : `https://front.travpromobile.com/${appId}/${link.substring(0, link.indexOf('.'))}.mp4`;
      return setType(newLink, '_blank', 'fas fa-volume-high', 'iframe', 'iframe', shareTitle);

    case 'youtube':
      return setType(`${link}`, '', 'fab fa-youtube', 'single_media_youtube', null, shareTitle);

    case 'pdf':
      return setType(
        `https://stack.travpromobile.com/viewer.php?file=${link}`,
        '_blank',
        'fas fa-file-pdf',
        'single_media_pdf',
        'iframe',
        shareTitle,
      );

    case 'infographic':
      return setType(link, '', 'fa fa-info', 'single_media', null, shareTitle);

    case 'vimeo':
      return setType(`https://vimeo.com/${link}`, '_blank', 'fab fa-vimeo', 'single_media_pdf', null, shareTitle);

    default: {
      console.warn('LinkButton switch/case defaulted: ', { typeWithoutIndex, link, type, appId, id });
    }
  }
  return false;
};

const setSlideShow = (links, data, shareTitle = '') => {
  const images = [];
  links.forEach(({ url, captions }) => {
    let imgixUrl = `${url.replace('s3.amazonaws.com/developertool', 'travprocdn.imgix.net')}?width=1000`;
    imgixUrl = `${imgixUrl.replace('front.travpromobile.com', 'travprocdn.imgix.net')}`;
    const key = url;
    const slideTitle = (captions && captions.toString().trim()) || (shareTitle && shareTitle.toString().trim()) || '';
    images.push(
      <a
        key={key}
        href={imgixUrl}
        rel={data}
        data-fancybox={data}
        data-caption={captions}
        data-options={JSON.stringify({
          buttons: ['thumbs', 'share', 'close'],
          share: {
            tpl: renderToString(<SharingPopup url={url} title={slideTitle} />),
          },
          btnTpl: { share: getFancyboxButtonShareTpl() },
        })}
      >
        <img src={imgixUrl} alt="" />
      </a>,
    );
  });
  return images;
};

export default class LinkButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: -1,
      isComplete: false,
      hasViewed: false,
    };
  }

  async componentDidMount() {
    const appId = await DataHandler.matchAppId();
    // Check StorageHandler for viewed state
    const { link, type } = this.props;
    const typeWithoutIndex = type.replace(/[0-9]/g, '');
    const viewedKey = `${appId}_${typeWithoutIndex}_${encodeURIComponent(link)}`;
    const visitedLinks = (await StorageHandler.load('visitedLinks')) || {};
    this.setState({ appId, hasViewed: !!visitedLinks[viewedKey] });
  }

  render() {
    const { completed, link, mandatory, type, index, trainingCompleted, shareTitle } = this.props;
    const { appId, isComplete, hasViewed } = this.state;
    const linkShareTitle = shareTitle && shareTitle.toString().trim() ? shareTitle.toString().trim() : '';

    // Check if type is one of the required types
    const typeWithoutIndex = type.replace(/[0-9]/g, '');
    const isRequiredType = REQUIRED_TYPES.includes(typeWithoutIndex);
    buttonCompleted = async () => {
      if (type === 'video') {
        trackShare('videos', link, link);
      }
      if (!isComplete && mandatory) {
        this.setState({ isComplete: true });
        completed();
      }
      const viewedKey = `${appId}_${typeWithoutIndex}_${encodeURIComponent(link)}`;
      let visitedLinks = (await StorageHandler.load('visitedLinks')) || {};
      visitedLinks[viewedKey] = true;
      StorageHandler.save('visitedLinks', visitedLinks);
      this.setState({ hasViewed: true });
    };

    const r = `slideshow${index}`;

    return (
      <div className="linkButton__container">
        {setButtonType(link, type, appId, r, linkShareTitle)}

        {type === 'textHtml' && <HtmlTextButton htmlText={this.props.htmlText} icon="tasks" />}

        {isRequiredType && !isComplete && !hasViewed && !trainingCompleted && (
          <FontAwesomeIcon
            icon={['fas', 'circle-exclamation']}
            className="linkButton__indicatorIcon"
            title="Unviewed link"
            aria-label="Unviewed link"
          />
        )}
        {settings?.fancybox?.includes('slideshow') && (
          <div className="hidden_images">{setSlideShow(link, r, linkShareTitle)}</div>
        )}
        {settings?.fancybox?.includes('single_media') && (
          <div className="hidden_single_media">
            <div
              id={settings.url}
              href={settings.url}
              data-fancybox={settings.fancybox}
              data-options={JSON.stringify({
                buttons: ['share', 'close'],
                share: {
                  tpl: renderToString(<SharingPopup url={link} title={linkShareTitle} />),
                },
                btnTpl: { share: getFancyboxButtonShareTpl() },
              })}
            />
          </div>
        )}
      </div>
    );
  }
}

ButtonElement.propTypes = {
  fancybox: PropTypes.string,
  icon: PropTypes.string,
  shareTitle: PropTypes.string,
  target: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
};

ButtonElement.defaultProps = {
  fancybox: '',
  icon: 'fa fa-question',
  shareTitle: '',
  target: '_blank',
  type: '',
  url: '',
};

LinkButton.propTypes = {
  completed: PropTypes.func,
  link: PropTypes.string,
  mandatory: PropTypes.bool,
  shareTitle: PropTypes.string,
  type: PropTypes.string,
  index: PropTypes.number,
  trainingCompleted: PropTypes.bool,
};

LinkButton.defaultProps = {
  completed: () => {},
  link: '#',
  mandatory: true,
  shareTitle: '',
  type: '',
  index: 1,
  trainingCompleted: false,
};
